import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import dayjs from "dayjs";
import Loader from "../../../core/common/selfLoder";
import { getFinancialYearList } from "../../../core/common/financialYear";

const OutdutyTeamCalendar2 = () => {
    const formatFinancialYear = (year: number) => {
        const nextYearShort = (year + 1).toString().slice(-2);
        return `${year}-${nextYearShort}`;
    };

    const getFinancialYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        return formatFinancialYear(year);
    };

    const [finance_year, setFinance_year] = useState(getFinancialYear());

    // Fetch team leave calendar
    const {
        data: teamLeaveCalenderData,
        loading: teamLeaveCalenderLoading,
    } = useApi("/api/manager/view-od-team-calendar", {
        method: "POST",
        autoCall: true,
        payload: { financial_year: finance_year },
    });

    useEffect(() => {
        if (teamLeaveCalenderData) {
            console.log(teamLeaveCalenderData?.data, "teamLeaveCalenderData....");
        }
    }, [teamLeaveCalenderData]);

    return (
        <>
            <Loader loading={teamLeaveCalenderLoading} />
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Team Out Duty Calendar</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.employeeDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Work & Operations</li>
                                    <li className="breadcrumb-item">Out Duty</li>
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.seflGrid}>Team Out Duty</Link>
                                    </li>
                                    <li
                                        className="breadcrumb-item active"
                                        aria-current="page"
                                    >
                                        Team Out Duty Calendar
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* Financial Year Selector */}
                            <div className="input-icon w-120 position-relative mb-2">
                                <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-9" />
                                </span>
                                {/* <select
                                    value={finance_year}
                                    onChange={(e) => setFinance_year(e.target.value)}
                                    className="form-select"
                                >
                                    {getFinancialYearList().map((fy) => (
                                          <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                                    ))}
                                </select> */}
                            </div>
                            <div className="ms-2 head-icons">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>

                    {/* Calendar */}
                    <div className="row">
                        <div className="col-md-12 col-xxl-12 col-xl-12 theiaStickySidebar">
                            <div className="stickybar">
                                <div className="card border-0">
                                    <div className="card-body">
                                        <FullCalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                            initialView="dayGridMonth"
                                            headerToolbar={{
                                                start: "today",
                                                center: "title",
                                                end: "prev,next",
                                            }}
                                            height="auto"
                                            dayCellContent={({ date }) => {
                                                const formatted = dayjs(date).format("YYYY-MM-DD");

                                                const leavesForDay =
                                                    teamLeaveCalenderData?.data?.filter(
                                                        (leave: any) => leave.from_date === formatted
                                                    ) || [];

                                                return (
                                                    <div
                                                        style={{ position: "relative", textAlign: "center" }}
                                                    >
                                                        {/* Date */}
                                                        <div style={{ fontWeight: "bold" }}>
                                                            {date.getDate()}
                                                        </div>

                                                        {/* Employees on leave */}
                                                        {leavesForDay.length > 0 && (
                                                            <div
                                                                style={{
                                                                    marginTop: "4px",
                                                                    fontSize: "0.7rem",
                                                                    lineHeight: "1rem",
                                                                    whiteSpace: "normal",
                                                                }}
                                                            >
                                                                {leavesForDay
                                                                    .map((leave: any) => ({
                                                                        ...leave,
                                                                        leave_type_short: leave.leave_type
                                                                    }))
                                                                    .map((leave: any) => (
                                                                        <div
                                                                            key={leave.leave_application_id}
                                                                            style={{
                                                                                fontSize: "13px",
                                                                                fontWeight: "600",
                                                                                color: "#2e3294",
                                                                            }}
                                                                        >
                                                                            {leave.employee_name} - {"OD"}
                                                                            {/* {leave.leave_type_short} */}
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer */}
                <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3">
                    <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>
        </>
    );
};

export default OutdutyTeamCalendar2;



// import React, { useEffect, useState } from "react";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import interactionPlugin from "@fullcalendar/interaction";
// import { Link } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import useApi from "../../../core/customhook/useApi";
// import dayjs from "dayjs";
// import Loader from "../../../core/common/selfLoder";
// import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// import weekOfYear from "dayjs/plugin/weekOfYear";

// dayjs.extend(isSameOrBefore);
// dayjs.extend(weekOfYear);

// interface Holiday {
//     holiday: string;
//     holiday_date: string;
//     holiday_category: string;
//     location: string;
// }

// interface HolidaysMainResponse {
//     success: boolean;
//     message: string;
//     statusCode: number;
//     data: Holiday[];
// }

// const OutdutyTeamCalendar2 = () => {
//     const [holidaySet, setHolidaySet] = useState<Set<string>>(new Set());
//     const [weekendSet, setWeekendSet] = useState<Set<string>>(new Set());
//     const formatFinancialYear = (year: number) => {
//         const nextYearShort = (year + 1).toString().slice(-2);
//         return `${year}-${nextYearShort}`;
//     };

//     const getCurrentFinancialYear = () => {
//         const today = new Date();
//         const year = today.getFullYear();
//         const month = today.getMonth();
//         const fyStart = month >= 3 ? year : year - 1;
//         return formatFinancialYear(fyStart);
//     };
//     const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

//     const {
//         data: holidayResponse,
//         loading: holidayLoading,
//         error: holidayError,
//     } = useApi<HolidaysMainResponse>("/api/holiday-list", {
//         method: "POST",
//         autoCall: true,
//         payload: {
//             category: "",
//         },
//     });

//     const {
//         data: weekendResponse,
//         loading: weekendLoading,
//         error: weekendError,
//     } = useApi("/api/weekend-rule", {
//         method: "GET",
//         autoCall: true,
//     });

//     const {
//         data: leave_details,
//         loading: leave_details_loading,
//         error: leave_Details_error,
//     } = useApi("/api/view-leave-status", {
//         method: "POST",
//         autoCall: true,
//         payload: {
//             financial_year: finance_year,
//         },
//     });
//     console.log(leave_details);
//     // State to hold events formatted for FullCalendar
//     const [events, setEvents] = useState<any>([]);

//     type LeaveStatus = "APPROVED" | "PENDING" | "REJECTED";

//     const statusColors: Record<
//         LeaveStatus,
//         { backgroundColor: string; borderColor: string; textColor?: string }
//     > = {
//         APPROVED: {
//             backgroundColor: "green",
//             borderColor: "green",
//             textColor: "#fff",
//         }, // Green for approved
//         PENDING: {
//             backgroundColor: "yellow",
//             borderColor: "#ccc",
//             textColor: "#000",
//         }, // Yellow for pending
//         REJECTED: {
//             backgroundColor: "red",
//             borderColor: "red",
//             textColor: "#fff",
//         }, // Red for rejected/disapproved
//     };

//     useEffect(() => {
//         if (holidayResponse?.data) {
//             const holSet = new Set(holidayResponse.data.map((h) => h.holiday_date));
//             const holidayEvents = holidayResponse.data.map((h) => ({
//                 id: `hol-${h.holiday_date}`,
//                 title: h.holiday,
//                 start: h.holiday_date,
//                 allDay: true,
//                 backgroundColor: "red",
//                 borderColor: "#0056b3",
//                 textColor: "#fff",
//             }));

//             let weekendDates: string[] = [];
//             const rule = weekendResponse?.data; // "Alternate" or "All"
//             const startOfYear = dayjs(`${finance_year.slice(0, 4)}-04-01`);
//             const endOfYear = startOfYear.add(1, "year").subtract(1, "day");
//             let curr = startOfYear.startOf("week"); // Sunday

//             while (curr.isBefore(endOfYear)) {
//                 // Sunday
//                 weekendDates.push(curr.format("YYYY-MM-DD"));
//                 // Saturday
//                 const sat = curr.add(6, "day");
//                 if (sat.isBefore(endOfYear)) {
//                     if (
//                         rule === "All" ||
//                         (rule === "Alternate" && sat.week() % 2 === 0)
//                     ) {
//                         weekendDates.push(sat.format("YYYY-MM-DD"));
//                     }
//                 }
//                 curr = curr.add(1, "week");
//             }

//             const weekendEvents = weekendDates.map((date) => ({
//                 id: `wd-${date}`,
//                 title: "Weekend",
//                 start: date,
//                 allDay: true,
//                 backgroundColor: "#ADD8E6",
//                 borderColor: "#ced4da",
//                 textColor: "#fff",
//             }));

//             setHolidaySet(holSet);
//             setWeekendSet(new Set(weekendDates));
//             setEvents((prev: any) => [...holidayEvents, ...weekendEvents, ...prev]);
//         }
//     }, [holidayResponse, weekendResponse, finance_year]);



//     useEffect(() => {
//         if (leave_details?.data) {
//             const leaveEvents: any[] = [];

//             const filteredLeaves = leave_details.data.filter(
//                 (item: any) => item.status?.toUpperCase() !== "REJECTED"
//             );

//             filteredLeaves.forEach((l: any) => {
//                 const {
//                     from_date,
//                     to_date,
//                     leave_type,
//                     status,
//                     leave_application_id,
//                     application_reason,
//                     leave_slice_type,
//                 } = l;

//                 const startDate = dayjs(from_date);
//                 const endDate = to_date ? dayjs(to_date) : null;

//                 // If it's a half-day leave
//                 const isHalfDay = leave_slice_type?.toLowerCase().includes("half");

//                 if (isHalfDay) {
//                     const date = startDate.format("YYYY-MM-DD");

//                     if (!holidaySet.has(date) && !weekendSet.has(date)) {
//                         leaveEvents.push({
//                             id: `leave-${leave_application_id}-${date}`,
//                             title: `${leave_type} (${leave_slice_type})`,
//                             start: date,
//                             allDay: true,
//                             ...statusColors[status as LeaveStatus],
//                             extendedProps: { application_reason, status },
//                         });
//                     }
//                 } else if (endDate) {
//                     // Full day / multi-day leave
//                     let curr = startDate;

//                     while (curr.isSameOrBefore(endDate, "day")) {
//                         const date = curr.format("YYYY-MM-DD");

//                         if (!holidaySet.has(date) && !weekendSet.has(date)) {
//                             leaveEvents.push({
//                                 id: `leave-${leave_application_id}-${date}`,
//                                 title: leave_type,
//                                 start: date,
//                                 allDay: true,
//                                 ...statusColors[status as LeaveStatus],
//                                 extendedProps: { application_reason, status },
//                             });
//                         }

//                         curr = curr.add(1, "day");
//                     }
//                 }
//             });

//             // Replace only leave-related events
//             setEvents((prev: any) => [
//                 ...prev.filter((e: any) => !e.id.startsWith("leave-")),
//                 ...leaveEvents,
//             ]);
//         }
//     }, [leave_details, holidaySet, weekendSet]);





//     // today Leave Employee
//     const employees = [
//         { id: 1, name: "Amit Sharma" },
//         { id: 2, name: "Priya Verma" },
//         { id: 3, name: "Rahul Singh" },
//     ];
//     const hasLeaves = employees.length > 0;

//     const {
//         data: teamLeaveCalenderData,
//         loading: teamLeaveCalenderLoading,
//         error: teamLeaveCalenderError,
//     } = useApi("/api/manager/team-leave-calender", {
//         method: "POST",
//         autoCall: true,
//         payload: {
//             financial_year: finance_year,
//         },
//     });

//     useEffect(() => {
//         console.log(teamLeaveCalenderData?.data, "teamLeaveCalenderData....");

//     }, [teamLeaveCalenderData])


//     return (
//         <>
//             <Loader loading={leave_details_loading} />
//             <div className="page-wrapper">
//                 <div className="content">
//                     <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//                         <div className="my-auto mb-2">
//                             <h2 className="mb-1">Team Out Duty Calendar                           </h2>
//                             <nav>

//                                 <ol className="breadcrumb mb-0">
//                                     <li className="breadcrumb-item">
//                                         <Link to={all_routes.employeeDashboard}>
//                                             <i className="ti ti-smart-home" />
//                                         </Link>
//                                     </li>
//                                     <li className="breadcrumb-item">Work & Operations</li>
//                                     <li className="breadcrumb-item">Out Duty</li>
//                                     <li className="breadcrumb-item">
//                                         <Link to={all_routes.seflGrid}>Team Out Duty</Link>
//                                     </li>
//                                     <li className="breadcrumb-item active" aria-current="page">
//                                         Team Out Duty Calendar
//                                     </li>
//                                 </ol>
//                             </nav>
//                         </div>
//                         <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
//                             <div className="me-2 mb-2"></div>
//                             <div className="input-icon w-120 position-relative mb-2">
//                                 <span className="input-icon-addon">
//                                     <i className="ti ti-calendar text-gray-9" />
//                                 </span>

//                                 <select
//                                     value={finance_year}
//                                     onChange={(e) => setFinance_year(e.target.value)}
//                                     className="form-select"
//                                 >
//                                     {(() => {
//                                         const today = new Date();
//                                         const currentYear =
//                                             today.getMonth() >= 3
//                                                 ? today.getFullYear()
//                                                 : today.getFullYear() - 1;

//                                         return Array.from({ length: 1 }, (_, i) => {
//                                             const year = currentYear - i;
//                                             const nextYearShort = String(year + 1).slice(-2);
//                                             const financialYear = `${year}-${nextYearShort}`;

//                                             return (
//                                                 <option key={financialYear} value={financialYear}>
//                                                     {financialYear}
//                                                 </option>
//                                             );
//                                         });
//                                     })()}
//                                 </select>
//                             </div>
//                             <div className="ms-2 head-icons">
//                                 <CollapseHeader />
//                             </div>
//                         </div>
//                     </div>


//                     <div className="row">
//                         <div className="col-md-12 col-xxl-12 col-xl-12  theiaStickySidebar">
//                             <div className="stickybar">
//                                 <div className="card border-0">
//                                     <div className="card-body">
//                                         <FullCalendar
//                                             plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//                                             initialView="dayGridMonth"
//                                             headerToolbar={{ start: "today", center: "title", end: "prev,next" }}
//                                             height="auto"
//                                             dayCellContent={({ date }) => {
//                                                 const formatted = dayjs(date).format("YYYY-MM-DD");

//                                                 // Filter employees who are on leave this day
//                                                 const leavesForDay = teamLeaveCalenderData?.data?.filter(
//                                                     (leave: any) => leave.from_date === formatted
//                                                 ) || [];

//                                                 return (
//                                                     <div style={{ position: "relative", textAlign: "center" }}>
//                                                         {/* Date */}
//                                                         <div style={{ fontWeight: "bold" }}>{date.getDate()}</div>

//                                                         {/* Employees */}
//                                                         {leavesForDay.length > 0 && (
//                                                             <div
//                                                                 style={{
//                                                                     marginTop: "4px",
//                                                                     fontSize: "0.7rem",
//                                                                     lineHeight: "1rem",
//                                                                     whiteSpace: "normal",
//                                                                 }}
//                                                             >
//                                                                 {leavesForDay
//                                                                     .map((leave: any) => ({
//                                                                         ...leave,
//                                                                         leave_type_short: leave.leave_type
//                                                                             .split(" ")
//                                                                             .map((word: string) => word[0])
//                                                                             .join("")
//                                                                     }))
//                                                                     .map((leave: any) => (
//                                                                         <div
//                                                                             key={leave.leave_application_id}
//                                                                             style={{ fontSize: "13px", fontWeight: "600", color: "#2e3294" }}
//                                                                         >
//                                                                             {leave.employee_name} - {leave.leave_type_short}
//                                                                         </div>
//                                                                     ))}

//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 );
//                                             }}
//                                         />

//                                     </div>

//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
//                     <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default OutdutyTeamCalendar2;

